module.exports = __webpack_public_path__ + "static/img/logo_jt_3.2a22a5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_jt_3.png
// module id = LJxF
// module chunks = 0